"use client";

import { useEffect, useState } from "react";
import { memoryMonitor, type MemoryStats } from "@/lib/debug/memory-monitor";

/**
 * Hook to monitor memory usage in development
 * Returns current memory stats and utilities
 */
export function useMemoryMonitor(enabled = true) {
  const [stats, setStats] = useState<MemoryStats | null>(null);
  const [isMonitoring, setIsMonitoring] = useState(false);

  useEffect(() => {
    // Only in development
    if (process.env.NODE_ENV !== "development" || !enabled) {
      return;
    }

    // Start monitoring
    memoryMonitor.start();
    setIsMonitoring(true);

    // Update stats every 5 seconds
    const interval = setInterval(() => {
      try {
        const currentStats = memoryMonitor.getStats();
        setStats(currentStats);
      } catch (e) {
        // No snapshots yet
      }
    }, 5000);

    return () => {
      clearInterval(interval);
      memoryMonitor.stop();
      setIsMonitoring(false);
    };
  }, [enabled]);

  return {
    stats,
    isMonitoring,
    getCurrentUsage: () => memoryMonitor.getCurrentUsage(),
    exportSnapshots: () => memoryMonitor.exportSnapshots(),
    clear: () => memoryMonitor.clear(),
  };
}
